<section class="slide-toggle-content" [ngClass]="{'slide-toggle-content-acmic':isAcmic}">
  <mat-slide-toggle class="mat-slide-toggle mat-accent" [checked]="checked" [disabled]="disabled" [color]="color"
    (change)="onToggleChange($event)">
    {{ label | translate }}
  </mat-slide-toggle>
</section>